import * as React from 'react';

import classNames from 'classnames';

export const Tooltip: React.FunctionComponent<{
	// tslint:disable-next-line: no-any
	children?: React.ReactElement<any, any>;
	disabled?: boolean;
	margin?: string;
	title: string;
	width?: string;
	position?: 'right' | 'top';
}> = ({ children, disabled, margin = 'mb-8', title, width = 'w-32', position = 'top' }) => {
	if (Boolean(disabled)) {
		return children ?? null;
	}

	return (
		<div className='relative flex flex-col items-center group'>
			{children}
			<div
				className={classNames(
					`absolute bottom-0 flex flex-col invisible items-center visible group-hover:visible ${width}`,
					{
						'left-2/4 ml-4': position === 'right',
						[margin]: position === 'top',
					}
				)}
				style={position === 'right' ? { marginBottom: '-10px' } : {}}
			>
				<span className='relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-gray-700 shadow-lg rounded-md'>
					{title}
				</span>
				<div
					className={classNames('w-3 h-3 -mt-2 bg-gray-700 transform rotate-45', {
						absolute: position === 'right',
					})}
					style={position === 'right' ? { left: '-5px', top: '50%' } : {}}
				/>
			</div>
		</div>
	);
};
